export const flowDictionary: { [key: string]: string } = {
  'business-loan': '107',
  'credit-score': '206',
  'business-valuation': '508',
  'cash-management': '600',
  dashboard: '302',
  'carbon-footprint': '700',
};
